import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ha-mypage l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "メールアドレス 変更", -1)
const _hoisted_3 = { class: "ha__sec ha-mypage__sec" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "ha__txt" }, [
  /*#__PURE__*/_createTextVNode("新しいメールアドレスを入力してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 送付された確認コードを入力すると変更が完了します。")
], -1)
const _hoisted_5 = { class: "ha-mypage__field-container has-mt" }
const _hoisted_6 = { class: "p-fields p-fields--confirm" }
const _hoisted_7 = { class: "c-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "現在のメールアドレス", -1)
const _hoisted_9 = { class: "c-field__body" }
const _hoisted_10 = { class: "p-errors" }
const _hoisted_11 = { class: "c-error" }
const _hoisted_12 = { class: "p-fields" }
const _hoisted_13 = { class: "c-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newEmail"
}, [
  /*#__PURE__*/_createTextVNode("新しいメールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_15 = { class: "c-field__body" }
const _hoisted_16 = { class: "c-field__input" }
const _hoisted_17 = { class: "c-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newEmailRetype"
}, [
  /*#__PURE__*/_createTextVNode("新しいメールアドレス(確認)"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_19 = { class: "c-field__body" }
const _hoisted_20 = { class: "c-field__input" }
const _hoisted_21 = { class: "ha__txt has-mt" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" ドメイン指定受信をご利用の方は「mail.id.shueisha.co.jp」 ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" をあらかじめ許可してください ")
const _hoisted_24 = { class: "c-field has-submit has-mt" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Form, {
        onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.changeEmail, this))),
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(({ errors, meta }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("fieldset", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.currentEmailRef), 1)
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.errorMsgRef), 1)
            ], 512), [
              [_vShow, _ctx.errorMsgRef]
            ]),
            _createElementVNode("fieldset", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "newEmail",
                      name: "newEmail",
                      modelValue: _ctx.newEmailRef,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newEmailRef) = $event)),
                      placeholder: "******@**.**.jp",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newEmail), 513), [
                [_vShow, errors.newEmail]
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "newEmailRetype",
                      name: "newEmailRetype",
                      modelValue: _ctx.newEmailRetypeRef,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newEmailRetypeRef) = $event)),
                      placeholder: "******@**.**.jp",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newEmailRetype), 513), [
                [_vShow, errors.newEmailRetype]
              ]),
              _createElementVNode("p", _hoisted_21, [
                _hoisted_22,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailDomains, (value) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createTextVNode("「" + _toDisplayString(value) + "」", 1)
                  ], 64))
                }), 256)),
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "ha-btn is-submit",
                  disabled: !meta.valid || _ctx.isDeterringRef
                }, _hoisted_27, 8, _hoisted_25),
                _createElementVNode("button", {
                  type: "button",
                  class: "ha-btn ha-btn--outline",
                  disabled: _ctx.isDeterringRef,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.backLinkageSite && _ctx.backLinkageSite(...args)))
                }, _hoisted_30, 8, _hoisted_28)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}